// assets/product-modal-fix.js
(() => {
  if (window.__nagisaneModalFix) return;
  window.__nagisaneModalFix = true;

  const getOpened = () => document.querySelector(".product-modal .modal__wrapper.is-open");

  const open = (wrapper) => {
    if (!wrapper) return;
    wrapper.classList.add("is-open");
    document.documentElement.classList.add("is-modal-open");
    document.body.classList.add("is-modal-open");
  };

  const close = (wrapper) => {
    if (!wrapper) return;
    wrapper.classList.remove("is-open");
    document.documentElement.classList.remove("is-modal-open");
    document.body.classList.remove("is-modal-open");
  };

  // ✅ “クリック”よりも取りこぼしにくい pointerdown を使う（スマホも強い）
  document.addEventListener(
    "pointerdown",
    (e) => {
      // 1) トリガー → 開く（トリガー直後の wrapper）
      const trigger = e.target.closest(".product-modal .modal__trigger");
      if (trigger) {
        const wrapper = trigger.nextElementSibling;
        if (wrapper && wrapper.classList.contains("modal__wrapper")) {
          open(wrapper);
        }
        return;
      }

      const opened = getOpened();
      if (!opened) return;

      // 2) × ボタン → 閉じる
      if (e.target.closest(".product-modal .modal__close")) {
        close(opened);
        return;
      }

      // 3) 黒背景（layer）→ 閉じる（これを最優先で保証）
      if (e.target.classList.contains("modal__layer")) {
        close(opened);
        return;
      }

      // 4) “本文以外”を押したら閉じる（画面どこでもに近い）
      //    ※本文内クリックは閉じない
      const inside = e.target.closest(".product-modal .modal__inner");
      if (!inside) {
        close(opened);
      }
    },
    { capture: true } // ✅ 既存テーマJSが stopPropagation してても拾いやすい
  );

  // ESCで閉じる
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    close(getOpened());
  });
})();